import { render, staticRenderFns } from "./DueDateBadge.vue?vue&type=template&id=1976a92f"
import script from "./DueDateBadge.vue?vue&type=script&lang=js"
export * from "./DueDateBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports